<!-- 自助洗车 -->
<template>
	<el-card shadow="never">
	    <div class="box" :style="{height:BoxHeight}">
			<div class="tips">
				<i class="iconfont icon-presentfill"></i>
				<div class="tips-text">服务接入中，敬请期待！</div>
			</div>
	    </div>
    </el-card>
</template>


<script>
import { MessageBox, Message, Loading } from 'element-ui'
import aucheck from '@/utils/aucheck.js';
export default {
	name:'MarketingMaintain',
	created(){
		this.getHeight();
		window.addEventListener("resize", this.getHeight);
	},
	destroyed() {
	    window.removeEventListener("resize", this.getHeight);
	},
	data(){
		return{
			BoxHeight:'768px',
		}
	},
	methods:{
		getHeight() {
			this.BoxHeight = window.innerHeight-176+'px';
    	}
	}
}
</script>

<style lang="scss" scoped>
.tips{
	text-align:center;
	margin-top:30px;
	color:#909399;
	.iconfont{
		font-size:160px;
	}
	.tips-text{
		margin-top:10px;
	}
}
</style>